export function money_mask(v: any) {
  v = v.replace(/\D/g, '');
  v = v.replace(/(\d{1})(\d{15})$/, '$1.$2');
  v = v.replace(/(\d{1})(\d{11})$/, '$1.$2');
  v = v.replace(/(\d{1})(\d{8})$/, '$1.$2');
  v = v.replace(/(\d{1})(\d{5})$/, '$1.$2');
  v = v.replace(/(\d{1})(\d{1,2})$/, '$1,$2');
  return `R$ ${v}`;
}
